export const ASSESSMENT_ERROR = 'ASSESSMENT_ERROR';
export const ASSESSMENT_GET = 'ASSESSMENT_GET';
export const ASSESSMENT_RATING_POST = 'ASSESSMENT_RATING_POST';
export const ASSESSMENT_RATING_POST_RESET = 'ASSESSMENT_RATING_POST_RESET';
export const ASSESSMENT_RATING_SAVE = 'ASSESSMENT_RATING_SAVE';
export const ASSESSMENT_RESULTS_GET = 'ASSESSMENT_RESULTS_GET';
export const ASSESSMENT_LOADING = 'ASSESSMENT_LOADING';
